import { __assign } from "tslib";
import React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapSubMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTSubMenu');
});
var bootStrapSubMenu = function (props) {
    return React.createElement(BootStrapSubMenu, __assign({}, props), props.children);
};
var SubMenu = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapSubMenu(props);
            break;
        default:
            componentToDisplay = bootStrapSubMenu(props);
            break;
    }
    return (React.createElement(React.Fragment, null, componentToDisplay));
};
SubMenu.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(SubMenu);
//# sourceMappingURL=SubMenu.js.map